export const getProcessedData = (data, initValues) => {
  if (!data?.length) {
    return null;
  }

  return initValues?.size
    ? data.filter((item) => initValues.has(item.id))
    : data;
};
